"use strict";
/*
 * Created on 02 22 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Tuple encapsulating {@link Product.id product id} and {@link Family.id. family id}.
 *
 * @author JMe
 */


var ProductFamilyTuple =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductFamilyTuple, _DomainObject_1$Domai);

  /**
   * @param productId internal id of internal product
   * @param familyId internal id of internal family
   */
  function ProductFamilyTuple(productId, familyId) {
    var _this;

    _classCallCheck(this, ProductFamilyTuple);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductFamilyTuple).call(this));
    _this.productId = productId;
    _this.familyId = familyId;
    return _this;
  }

  return ProductFamilyTuple;
}(DomainObject_1.DomainObject);

exports.ProductFamilyTuple = ProductFamilyTuple;